<script>

export default {
    name: 'LinhaDeListaDeDados',
    props: ["usuarioStore", "dado", "controlesDesativados", "temPermissaoDelete"],
    emits: ["update:alteraDado", "update:alteraVisualizandoDado", "update:alteraEditandoDado", "delete"],
    methods: {
        abrirVisualizarDado(dado) {
            this.$emit('update:alteraVisualizandoDado', { visualizandoDado: true, dado: dado });
        },
        abrirEditarDado(dado) {
            this.$emit('update:alteraEditandoDado', { editandoDado: true, dado: dado });
        },
        abrirDeletarDado(dado) {
            this.$emit('delete', dado);
        },
        getStatusColor(status) {
            switch(status) {
                case 'Elaborado': return 'success';
                case 'Cancelado': return 'error';
                case 'Elaboração': return 'warning';
                default: return 'grey';
            }
        }
    }
};

</script>

<template>

    <div class="c-linha" :class="{ 'c-linha--disabled': controlesDesativados }">
        
        <div class="c-linha__cell c-linha__acoes">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        @click="abrirVisualizarDado(dado)"
                    >
                        <v-icon dark>mdi-eye</v-icon>
                    </v-btn>
                </template>
                <span>Visualizar Desenho</span>
            </v-tooltip>
        </div>

        <div class="c-linha__cell c-linha__acoes">
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="success"
                        v-bind="attrs"
                        v-on="on"
                        @click="abrirEditarDado(dado)"
                    >
                        <v-icon dark>mdi-pencil</v-icon>
                    </v-btn>
                </template>
                <span>Editar Desenho</span>
            </v-tooltip>

            <v-tooltip bottom v-if="temPermissaoDelete">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        class="mx-1"
                        fab
                        dark
                        small
                        color="error"
                        v-bind="attrs"
                        v-on="on"
                        @click="abrirDeletarDado(dado)"
                    >
                        <v-icon dark>mdi-delete</v-icon>
                    </v-btn>
                </template>
                <span>Deletar Desenho</span>
            </v-tooltip>
        </div>

        <div class="c-linha__cell">{{ dado.sequential || '-' }}</div>
        <div class="c-linha__cell">{{ dado.descriptionDes || '-' }}</div>
        <div class="c-linha__cell">
            <v-chip 
                :color="getStatusColor(dado.status)"
                small
                dark
            >
                {{ dado.status || 'Elaboração' }}
            </v-chip>
        </div>
        <div class="c-linha__cell">{{ dado.numeroCliente || '-' }}</div>
        <div class="c-linha__cell">{{ dado.fomatDocument || '-' }}</div>

    </div>

</template>

<style scoped>

.c-linha {
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: 1px solid #e0e0e0;
    transition: background-color 0.2s ease;
}

.c-linha:hover {
    background-color: #f9f9f9;
}

.c-linha--disabled {
    opacity: 0.6;
    pointer-events: none;
}

.c-linha__cell {
    padding: 12px 10px;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333;
}

.c-linha__acoes {
    gap: 5px;
}

</style>
